import { useState, useEffect } from 'react'
import { useUser } from '../useUser'
import { apiGet } from '../../Api_Functions'

function useLicensePlanner () {
  const [planner, setPlanner] = useState(null)
  const { user } = useUser()

  useEffect(() => {
    if (!user) return

    const fetchPlannerPermissions = async () => {
      try {
        const result = await apiGet('license/planner')
        setPlanner(result.code)
      } catch (error) {
        console.error('Failed to fetch planner:', error)
      }
    }
    fetchPlannerPermissions()
  }, [user])

  return planner
}

export default useLicensePlanner
